module.exports = __webpack_public_path__ + "media/assets/img/video/line-5fc5717a9edff8e0e39d4d5cab888013.svg";